'use client';

import { useEffect } from 'react';

import { useModel } from '@/hooks/useModel';
import useChatStore from '@/store/useChatStore';
import { EVENT } from '@/utils/event';

/**
 * 使用 Chat Manager Hook
 * @param options.allowAnonymous - 是否允许匿名用户（默认 false）
 * @returns sessionSocketManager
 */
export function useChatManager(options?: { allowAnonymous?: boolean }) {
  const { allowAnonymous = false } = options || {};

  const { userProfile } = useModel('auth-model', (model) => ({
    userProfile: model.userProfile
  }));

  const { sessionSocketManager, initSocketManager, destroySocketManager } = useChatStore();

  useEffect(() => {
    initSocketManager({
      userId: userProfile?.userId,
      allowAnonymous
    });

    return () => {
      // 组件卸载时不销毁，因为可能其他地方还在使用
      // 只在用户登出时销毁
    };
  }, [userProfile?.userId, allowAnonymous, initSocketManager]);

  // 监听登出事件，销毁 manager
  useEffect(() => {
    const handleLogout = () => {
      destroySocketManager();
    };

    window.addEventListener(EVENT.LOG_OUT, handleLogout);

    return () => {
      window.removeEventListener(EVENT.LOG_OUT, handleLogout);
    };
  }, [destroySocketManager]);

  return { sessionSocketManager };
}
